"use client"
import { getImageSrc, getVideoProp, VideoProps, FULL_WIDTH } from "@itchannelplus/utils";
import Image from "next/image";
import  { useEffect, useState } from "react";
import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";
import ReactPlayer from "react-player";

export const EmbedVideo = styled('div' , {
  css: [styles.embedVideo],
  variants: {
    loaded: {
      true: styles.loaded
    }
  }
})
export const PlayButton = styled('button' , {
  css: [styles.playButton],
  variants: {
    visible: {
      true: styles.visible
    },
    paused: {
      true: styles.paused
    }
  }
})

const Video = ( {video, light, playing, controls, ...props}: {video:VideoProps, light?:boolean, playing?: boolean, controls?: boolean, [key: string]: any } ) => {
  const [isIFrameLoaded, setIsIFrameLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(playing || video.autoplay || false);
  useEffect(() => {
    setIsPlaying(playing!);
  }, [playing]);
  const autoplay = video.autoplay || video.background;
  const muted = video.muted || autoplay;
  const loop = video.loop || video.background;
  const poster = light && !autoplay && video.poster ? getImageSrc(video.poster) || light : false;
  const options:Record<string, any> = {};
  if (autoplay) { options['autoplay'] = autoplay; }
  if (video.background) { options['background'] = video.background; }
  return <EmbedVideo loaded={!video.poster || isIFrameLoaded}  {...props}>
        <ReactPlayer src={getVideoProp('src', video)} width="100%" height="100%"
                     muted={muted}
                     playing={isPlaying}
                     light={poster}
                     loop={loop}
                     controls={video.controls || controls}
                     config={{
                       vimeo: {
                         ...options,
                       }
                     }}
                     fallback={video.poster ? <Image src={getImageSrc(video.poster)}  alt={video.title || video.alt || "Video Poster"}  fill sizes={FULL_WIDTH} /> : null }
                     onReady={() => setIsIFrameLoaded(true)}


        />
      {!video.background && <PlayButton onClick={() => setIsPlaying(!isPlaying)} paused={isPlaying}>PLAY</PlayButton>}
      </EmbedVideo>
}

export default Video;
